import {Mapper} from '@s-ui/domain'

const SUBSCRIPTION_CAROUSEL_ADS_AMOUNT = 3

const getShuffledAds = ads =>
  ads
    .map(a => [Math.random(), a])
    .sort((a, b) => a[0] - b[0])
    .map(a => a[1])

const getUniqueAdsByMake = ads =>
  ads.reduce((filteredAds, currentAd) => {
    const {make: currentAdMake} = currentAd

    if (filteredAds.some(({make}) => make === currentAdMake)) {
      return filteredAds
    }

    return [...filteredAds, currentAd]
  }, [])

export class FromAdsListValueObjectToSubscriptionCarouselAdsListValueObjectMapper extends Mapper {
  constructor({adsListValueObjectFactory}) {
    super()
    // Value Objects
    this._adsListValueObjectFactory = adsListValueObjectFactory

    this._hasMakeFilter = false
  }

  setParams = ({hasMakeFilter = false}) => {
    this._hasMakeFilter = hasMakeFilter
    return this
  }

  map = adsListValueObject => {
    const ads = adsListValueObject.getItems() || []

    const adsWithMake = ads.map(ad => {
      const {title, ...rest} = ad.toJSON()
      const [make] = title.split(' ')
      return {...rest, title, make}
    })

    if (this._hasMakeFilter)
      return this._adsListValueObjectFactory({
        ...adsListValueObject.toJSON(),
        items: ads.slice(0, SUBSCRIPTION_CAROUSEL_ADS_AMOUNT)
      })

    const shuffledAds = getShuffledAds(adsWithMake)

    const uniqueAdsByMake = getUniqueAdsByMake(shuffledAds)

    const items = uniqueAdsByMake.slice(0, SUBSCRIPTION_CAROUSEL_ADS_AMOUNT)

    return this._adsListValueObjectFactory({
      ...adsListValueObject.toJSON(),
      items
    })
  }
}
